import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

/**
 * MiContext - Minimal Passive Bridge
 * 
 * This context serves as a "Mirror" for the AI UI to consume state
 * that is managed locally within App.js. No business logic lives here.
 */
const MiContext = createContext();

export const useMi = () => useContext(MiContext);

export const MiProvider = ({ children }) => {
  // ── Mirrored UI State ──
  const [bridgeState, setBridgeState] = useState({
    mi: { mood: 'neutral', message: 'Mi sincronizando...', context: 'SISTEMA' },
    chatMessages: [],
    setChatMessages: () => {},
    chatInput: '',
    setChatInput: () => {},
    isChatOpen: false,
    isChatSending: false,
    credits: 0,
    activeTab: 'hub',
    setActiveTab: () => {},
    isAuthenticated: false,
    isOnboardingActive: false,
    isProcessing: false,
    coachStatus: { status: 'idle', progress: 0, subStatus: '' },
    sensiStatus: { status: 'idle', progress: 0, subStatus: '' }
  });

  // ── Dispatcher Ref Bridge (to avoid re-renders) ──
  // This allows the Shell to trigger handleChat defined in App.js
  const [handleChatRef, setHandleChatRef] = useState({ current: null });

  const syncMiState = useCallback((newState) => {
    setBridgeState(prev => ({ ...prev, ...newState }));
  }, []);

  const value = useMemo(() => ({
    ...bridgeState,
    syncMiState,
    handleChatRef,
    setHandleChatRef
  }), [bridgeState, handleChatRef, syncMiState]);

  return (
    <MiContext.Provider value={value}>
      {children}
    </MiContext.Provider>
  );
};
